import React, { useState, useEffect } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';

import { saveAs } from 'file-saver';

import ListaUsuarioBuyer from './ListaUsuarioBuyer';

import {
    listarUsuariosBuyer,
    ligarPorFiltroUsuariosBuyer,
    gerarExcelUsuarios
} from '../../../../services/http/buyerService';

import './styles.scss';

const UsuarioBuyer = ({ chamarForm, idEmpresa }) => {
    const { addSnackBar } = useSnackBar();

    const [busca, setBusca] = useState('');
    const [listaUsuariosBuyer, setUsuariosBuyer] = useState(
    {
        numeroPagina: 0,
        totalPaginas: 0,
        lista: [],
        tamanhoPagina: 0,
        hasPreviousPage: false,
        hasNextPage: false
    });

    const CarregarListaUsuariosBuyer = (pagina) => {
        trackPromise(
            listarUsuariosBuyer(idEmpresa, pagina)
                .then(res => {
                    if (res.data) {
                        setUsuariosBuyer(res.data);
                    }
                })
        ).catch(error => {
            console.log('Erro ao carregar lista de Usuários');
        })
    }

    const CarregarListaUsuariosBuyerComFiltro = (filtro, pagina) => {
        trackPromise(
            ligarPorFiltroUsuariosBuyer(idEmpresa, filtro, pagina)
                .then(res => {
                    if (res.data) {
                        setUsuariosBuyer(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar Usuários', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar Usuários', info: 'error', open: true });
        })
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    const extrairBase = () => {
        trackPromise(
            gerarExcelUsuarios(idEmpresa)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "usuariosBuyer.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base com Usuários', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base com Usuários', info: 'error', open: true });
        })
    }

    const mudarPaginaLoja = (page) => {
        busca != "" ? CarregarListaUsuariosBuyerComFiltro(busca, page) : CarregarListaUsuariosBuyer(page);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaUsuariosBuyerComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaUsuariosBuyer(1);
        }

    }, [busca]);

    return (
        <div>
            <ListaUsuarioBuyer
                data={listaUsuariosBuyer}
                mudarPagina={mudarPaginaLoja}
                buscar={buscar}
                busca={busca}
                chamarForm={chamarForm}
                gerarExcel={extrairBase}
            />
        </div>
    )
}

export default UsuarioBuyer;